export default __webpack_public_path__ + "static/media/drac5@3x.63b1abf2.png";